/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function MasterDetailIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "master-detail", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("rect", { x: 4.5, y: 5.5, width: 16, height: 14, stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M10.5 5.5V19.5", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M6 8.5H9", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M13 8.5H18", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M6 11.5H9", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M6 14.5H9", stroke: "currentColor", strokeWidth: 1.2 })));
}
const ForwardRef = React.forwardRef(MasterDetailIcon);
export default ForwardRef;
//# sourceMappingURL=masterDetailIcon.js.map